// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__szOcg","back":"Login_back__-CQea","loginCard":"Login_loginCard__CLTM8","logo":"Login_logo__KQRRZ","submitBtn":"Login_submitBtn__RhFKF"};